import { GlAlert, GlFormGroup, GlModal } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { joinPaths, visitUrl } from '~/lib/utils/url_utility';
import { getRegistryItem } from '../item_type_registry.js?vue3';
import FormProjectDropdown from './form_project_dropdown.vue?vue3';
export default {
    name: 'ProjectRedirectModal',
    components: {
        FormProjectDropdown,
        GlAlert,
        GlFormGroup,
        GlModal
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        open: {
            type: Boolean,
            required: false,
            default: false
        },
        modalId: {
            type: String,
            required: false,
            default: 'project-redirect-modal'
        }
    },
    emits: [
        'hide'
    ],
    data () {
        return {
            isOpen: this.open,
            selectedProject: null,
            isDirty: false,
            error: null
        };
    },
    computed: {
        itemRegistry () {
            return getRegistryItem(this.item.itemType);
        },
        modal () {
            return {
                actionPrimary: {
                    text: __('Continue'),
                    attributes: {
                        variant: 'confirm'
                    }
                },
                actionCancel: {
                    text: __('Cancel')
                }
            };
        },
        projectId () {
            return this.selectedProject?.id || null;
        },
        isProjectValid () {
            if (!this.isDirty) return true;
            return Boolean(this.selectedProject);
        },
        projectInvalidFeedback () {
            return s__('AICatalog|Project is required.');
        }
    },
    methods: {
        onError (error) {
            this.error = error;
        },
        continueToProject () {
            this.isDirty = true;
            if (!this.isProjectValid) {
                return;
            }
            const automatePath = this.itemRegistry.namespacePath;
            const itemId = getIdFromGraphQLId(this.item.id);
            visitUrl(joinPaths(this.selectedProject.webPath, automatePath, itemId.toString(), 'duplicate'));
            this.isOpen = false;
        },
        resetForm () {
            this.selectedProject = null;
            this.isDirty = false;
            this.error = null;
        },
        onHidden () {
            this.resetForm();
            this.$emit('hide');
        }
    }
};
